import { ContactHubSection } from "@/components/sections/contact-hub-section";
import { PageIntroSection } from "@/components/sections/page-intro";
import { Seo } from "@/components/seo/seo";
import { useSiteContent } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";
import { absoluteUrl } from "@/lib/seo-url";
import { contactPageJsonLd } from "@/lib/structured-data";

export function ContactPage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();
  const url = absoluteUrl(`/${locale}/contact`);

  return (
    <>
      <Seo
        description={content.pages.contact.description}
        jsonLd={contactPageJsonLd(content, url)}
        locale={locale}
        pathWithoutLocale="/contact"
        title={content.pages.contact.title}
      />
      <PageIntroSection content={content.pages.contact} />
      <ContactHubSection content={content.contact} />
    </>
  );
}
